import { IconProps } from "../../utils/global-types/global-types";

const MaximizeIcon = ({ className, ...rest }: IconProps) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 14 14"
  className={className ? className : "w-[14px] h-[14px]"}
  {...rest}
>
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    d="M12.25 5.25v-3.5h-3.5M1.75 8.75v3.5h3.5M12.25 1.75 7.875 6.125M6.125 7.875 1.75 12.25"
  ></path>
</svg>
);

export default MaximizeIcon;
